import React from 'react';
import './home.css'
import Supportmangement from '../sections/sec-support';

const Supportmsg = () => {
    return ( 
        <>
        <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Supportmangement />
        </section>
        </>
     );
}
 
export default Supportmsg;